import { render, staticRenderFns } from "./ModalConceptoUniversidad.vue?vue&type=template&id=163a98d4"
import script from "./ModalConceptoUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalConceptoUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports